module.exports = __webpack_public_path__ + "img/第六期.c841b0dc.png";